import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { DoctorService } from 'app/modules/doctor/services/doctor.service';
import { IDropDown } from '../../models/IDropDown';
import { RegistroService } from '../../../services/registro.service';
import moment from 'moment';
import { CurrenyService } from 'app/modules/common/services/curreny.service';

@Component({
    selector: 'app-reunion-popup',
    templateUrl: './reunion-popup.component.html',
    styleUrls: ['./reunion-popup.component.scss'],
    standalone: false
})
export class ReunionPopupComponent implements OnInit {

  public reunionForm: UntypedFormGroup
  public activeDoctorList: IDropDown<string>[]

  constructor(
    public _dialogRef: MatDialogRef<ReunionPopupComponent>,
    public _fb: UntypedFormBuilder,
    private _sharedService: SharedService,
    public currencyService: CurrenyService,
    private _registroService: RegistroService,
    public _doctorService: DoctorService,
    @Inject(MAT_DIALOG_DATA)
    private _dialogData: any
  ) {
    this.GetCommonDoctorsList()    
    //creates the form with default values
    this.CreateReunionSmeForm(_dialogData.companyId);   
    
    if(_dialogData.id != null){
      //get data for selected id from the list  
      this.GetReunionSmeById(_dialogData.id)
    }
    
  }
  
  UpdateFieldsWithApiData(reunion:any)
  { 
    this.reunionForm.patchValue({
      Id: reunion.id,
      Fecha: reunion.fecha,
      Horas: reunion.horas,
      HorasDesplazamiento: reunion.horasDesplazamiento,
      MedicoId: reunion.medicoId,
      Asunto: reunion.asunto,
      Asistentes: reunion.asistentes,
      Comentarios: reunion.comentarios
    });
  
    this.reunionForm = this.setSpanishCurrencyValues(this.reunionForm);
  }

  ngOnInit(): void {
  }


  private ConvertDateToStringSpanishFormat():UntypedFormGroup {      
    //This to avoid date reduce by 12 hours and when recieveing at the API  
    let getDate = this.reunionForm.get('Fecha').value
    let formatedStringDate = moment(getDate).format('MM/DD/YYYY')
    //remove refference and create a new form object
    let formObject = {...this.reunionForm.value} 
    formObject.Fecha = formatedStringDate
    return formObject
  }


  private CreateReunionSmeForm(companyId: number): void {
    this.reunionForm = this._fb.group({
      Id: [0],
      EmpresaId: [companyId],
      Fecha: ['', Validators.required],
      Horas: [null],
      HorasDesplazamiento: [null],
      MedicoId: [null],
      Asunto: [null],
      Asistentes: [null],
      Comentarios: [null]
    })
  }

  public onSubmit() { 
    this.reunionForm.markAllAsTouched();
    this.reunionForm = this.setNumricCurrencyValues(this.reunionForm);
    this.reunionForm.updateValueAndValidity();

    if (this.reunionForm.valid) {
      //This to avoid date reduce by 12 hours and when recieveing in API       
      let updatedForm = this.ConvertDateToStringSpanishFormat()

      if (this.reunionForm.value.Id === 0) {
        this.AddReunionSme(updatedForm)
      } else {
        this.UpdateReunionSme(updatedForm)
      }
    }
  }
  cancel(submitSuccess: boolean) {
    this._dialogRef.close(submitSuccess == null ? false : submitSuccess);
  }

  private AddReunionSme(updatedForm) {    
    this._registroService.AddReunionSme(updatedForm)
      .subscribe(res => {
        if (res.code === 0) {
          this._sharedService.ShowSnackBar('Guardado con éxito', 'Okay', 2000);
          this.cancel(true)
        } else {
          this._sharedService.ShowSnackBar('Error al crear', 'Okay', 2000);
        }
      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
      });
  }

  private UpdateReunionSme(updatedForm) {    
    this._registroService.UpdateReunionSme(updatedForm)
      .subscribe(res => {
        if (res.code === 0) {
          this._sharedService.ShowSnackBar('Actualizado con éxito', 'Okay', 2000);
          this.cancel(true)
        } else {
          this._sharedService.ShowSnackBar('Error al guardar', 'Okay', 2000);
        }
      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
      });
  }

  private GetCommonDoctorsList() {
    this._doctorService.GetActiveDoctorsDropdown()
      .subscribe(res => {
        this.activeDoctorList = res
      });
  }

  private GetReunionSmeById(id) {    
    this._registroService.GetReunionSmeById(id)
      .subscribe(res => {
        if(res.result != null)
            this.UpdateFieldsWithApiData(res.result)             
      });      
}

private setNumricCurrencyValues(form: UntypedFormGroup): UntypedFormGroup {  
  const values = form.value;

  values.Horas = String(values.Horas).includes(',') ? this.currencyService.replaceSpanishFormat(String(values.Horas)) : Number(values.Horas);
  values.HorasDesplazamiento = String(values.HorasDesplazamiento).includes(',') ? this.currencyService.replaceSpanishFormat(String(values.HorasDesplazamiento)) : Number(values.cantidad);

  return this.patchSpanishFormData(form, values);
}

private setSpanishCurrencyValues(form: UntypedFormGroup): UntypedFormGroup {  
  const values = form.value;
  
  values.Horas = values.Horas ? this.currencyService.setSpanishCurreny(values.Horas) : values.Horas;
  values.HorasDesplazamiento = values.HorasDesplazamiento ? this.currencyService.setSpanishCurreny(values.HorasDesplazamiento) : values.HorasDesplazamiento;

  return this.patchSpanishFormData(form, values);
}

private patchSpanishFormData(form: UntypedFormGroup, values: any): UntypedFormGroup {
  form.patchValue({
    Horas: values.Horas,
    HorasDesplazamiento: values.HorasDesplazamiento,
  });

  return form;
}

}
